// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__19Fup","importantInfo":"styles_importantInfo__2Ydqq"};